// extracted by mini-css-extract-plugin
export default {"sendToAppBannerContainer":"_3mxCg","title":"_1ObK3","appReviews":"_1ejaO","mobileDevicesImage":"_2cSBn","downloadCta":"_1uZXV"};